import useGet from "../hooks/useGet";
import {backendEndpoints} from "../../libs/backendEndpoints";
import moment from "moment";
import {defaultDateTimeFormat} from "../../utils/date";
import Modal from "react-bootstrap/Modal";
import {useState} from "react";
import Button from "react-bootstrap/Button";
import {Alert, Loading} from "fearless-common-ui";

interface LoggedMail {
  id: number;
  title: string | null;
  email: string | null;
  contents: string;
  created_at: string| null;
}

/**
 * Display a table with all the mails sent to the user
 */
export default function AdminLoggedMails({ userId }: { userId: number }) {
  const [selectedMail, setSelectedMail] = useState<LoggedMail | null>(null);
  const { data, isLoading, error } = useGet<LoggedMail[]>({
      endpoint: backendEndpoints.getAdminLoggedMail,
      params: {
          user_id: userId,
      },
  });

  return (
    <>
      {isLoading && <Loading />}
      {error && <Alert>{error}</Alert>}
      <table className="table table-sm text-sm table-striped">
        <thead>
        <tr>
          <th>Date sent</th>
          <th>Mail subject</th>
          <th>Address</th>
          <th>&nbsp;</th>
        </tr>
        </thead>
        <tbody>
          {Array.isArray(data) && data.map((mail) => (
            <tr key={mail.id}>
              <td>{moment(mail.created_at).format(defaultDateTimeFormat)}</td>
              <td>{mail.title}</td>
              <td>{mail.email}</td>
              <td>
                <Button variant="outline-primary" size="sm" onClick={() => setSelectedMail(mail)}>Show</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {selectedMail && (
        <Modal show size="lg" onHide={() => setSelectedMail(null)}>
          <Modal.Header closeButton>
            <Modal.Title>Mail sent at {moment(selectedMail.created_at).format(defaultDateTimeFormat)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div dangerouslySetInnerHTML={{ __html: selectedMail.contents }} />
          </Modal.Body>
        </Modal>
      )}
    </>
  )
}
